export const FEATURE_STORE_GATE = 'Growth:FeatureStore';
export const STARTER_GWP_GATE = 'CBX:StarterSuiteGWP';